import router from './router'
import store from './store'
import { Message } from 'element-ui'
import { storGet, storRemove } from '@/utils/request'
import getPageTitle from '@/utils/get-page-title'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
NProgress.configure({ showSpinner: false }) // NProgress Configuration
import { constantRoutes, statisticRoutes } from "./router";
// console.log(storGet('screen'))
const whiteList = ['/login', '/lockIe']
router.beforeEach((to, from, next) => {
  NProgress.start()
  const token = storGet('screen')
  document.title = getPageTitle(to.meta.title)
  const count = store.state.user.count
  if (token) {
    if (!token.id) {
      Message.warning('登录信息失效！请重新登录！')
      storRemove('screen')
      next('/login')
      return false
    }
    if(window.location.href.indexOf('lc.eartip.cn') !== -1 && token.account != '13300000000') {
      localStorage.clear()
      next('/login')
      return false
    }
    console.log(count, 'count token')
    if (count == 1 ) {
      console.log(count)
      const routes = storGet('screen').customerGroupId == 23 ? statisticRoutes : constantRoutes
      router.options.routes = routes
      router.addRoutes(routes)
      store.state.user.count++
      next({ ...to, replace: true })
      NProgress.done()
    } else {
      next()
      NProgress.done()
    }
    // if (to.path === '/login') {
    //   next({ path: '/' })
    //   NProgress.done()
    // } else {
    //   next()
    //   NProgress.done()
    // }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})
router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
